/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * NOT_EQUAL operator looks for values in the given key that are not equal to the given value.
 */
export interface KeyNotEqualAnnotationKeyAnnotationValue {
    /** The key to compare against. */
    key: string;
    /** The value to compare against. */
    value: string;
}
